import { render, staticRenderFns } from "./pastChamp.vue?vue&type=template&id=0ecc0270&scoped=true&"
import script from "./pastChamp.vue?vue&type=script&lang=js&"
export * from "./pastChamp.vue?vue&type=script&lang=js&"
import style0 from "./pastChamp.vue?vue&type=style&index=0&id=0ecc0270&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecc0270",
  null
  
)

export default component.exports